import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPost, AxiosPatch, AxiosDelete, AxiosFile } from '../../../utils/axios';
import * as actions from './actions';

function* fetchAdminProducts({ payload }) {
  try {
    const { filters = {} } = payload;

    // Build query parameters
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.active !== undefined && filters.active !== '') {
      params.append('active', filters.active);
    }
    if (filters.page) params.append('page', filters.page);
    if (filters.page_size) params.append('page_size', filters.page_size);

    const queryString = params.toString();
    const url = queryString ? `/products-admin/?${queryString}` : '/products-admin/';

    const result = yield call(AxiosCall, url);
    yield put(actions.fetchAdminProductsSuccess(result.data));
  } catch (error) {
    yield put(actions.fetchAdminProductsFailure(error));
  }
}

function* fetchAdminProduct({ payload }) {
  try {
    const { id } = payload;
    const result = yield call(AxiosCall, `/products-admin/${id}/`);
    yield put(actions.fetchAdminProductSuccess(result.data));
  } catch (error) {
    yield put(actions.fetchAdminProductFailure(error));
  }
}

function* createProduct({ payload }) {
  try {
    const { data, onSuccess } = payload;
    const result = yield call(AxiosPost, '/products-admin/', data);
    yield put(actions.createProductSuccess(result.data));
    if (onSuccess) onSuccess(result.data);
  } catch (error) {
    yield put(actions.createProductFailure(error));
  }
}

function* updateProduct({ payload }) {
  try {
    const { id, data, onSuccess } = payload;
    const result = yield call(AxiosPatch, `/products-admin/${id}/`, data);
    yield put(actions.updateProductSuccess(result.data));
    if (onSuccess) onSuccess(result.data);
  } catch (error) {
    yield put(actions.updateProductFailure(error));
  }
}

function* deleteProduct({ payload }) {
  try {
    const { id, onSuccess } = payload;
    yield call(AxiosDelete, `/products-admin/${id}/`);
    yield put(actions.deleteProductSuccess(id));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(actions.deleteProductFailure(error));
  }
}

function* uploadProductImages({ payload }) {
  try {
    const { productId, images, onSuccess } = payload;

    const formData = new FormData();
    images.forEach((image) => {
      formData.append('images', image);
    });

    const result = yield call(AxiosFile, `/products-admin/${productId}/upload_images/`, formData);
    yield put(actions.uploadProductImagesSuccess(result.data));
    if (onSuccess) onSuccess(result.data);
  } catch (error) {
    yield put(actions.uploadProductImagesFailure(error));
  }
}

function* deleteProductImage({ payload }) {
  try {
    const { productId, imageId, onSuccess } = payload;
    yield call(AxiosDelete, `/products-admin/${productId}/delete_image/${imageId}/`);
    yield put(actions.deleteProductImageSuccess(productId, imageId));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(actions.deleteProductImageFailure(error));
  }
}

function* fetchPresentations({ payload }) {
  try {
    const { productId } = payload;
    const result = yield call(AxiosCall, `/presentations-admin/?product=${productId}`);
    yield put(actions.fetchPresentationsSuccess(result.data));
  } catch (error) {
    yield put(actions.fetchPresentationsFailure(error));
  }
}

function* createPresentation({ payload }) {
  try {
    const { data, onSuccess } = payload;
    const result = yield call(AxiosPost, '/presentations-admin/', data);
    yield put(actions.createPresentationSuccess(result.data));
    if (onSuccess) onSuccess(result.data);
  } catch (error) {
    yield put(actions.createPresentationFailure(error));
  }
}

function* updatePresentation({ payload }) {
  try {
    const { id, data, onSuccess } = payload;
    const result = yield call(AxiosPatch, `/presentations-admin/${id}/`, data);
    yield put(actions.updatePresentationSuccess(result.data));
    if (onSuccess) onSuccess(result.data);
  } catch (error) {
    yield put(actions.updatePresentationFailure(error));
  }
}

function* deletePresentation({ payload }) {
  try {
    const { id, onSuccess } = payload;
    yield call(AxiosDelete, `/presentations-admin/${id}/`);
    yield put(actions.deletePresentationSuccess(id));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(actions.deletePresentationFailure(error));
  }
}

export default function* productsSaga() {
  yield all([
    takeLatest(actions.FETCH_ADMIN_PRODUCTS.REQUEST, fetchAdminProducts),
    takeLatest(actions.FETCH_ADMIN_PRODUCT.REQUEST, fetchAdminProduct),
    takeLatest(actions.CREATE_PRODUCT.REQUEST, createProduct),
    takeLatest(actions.UPDATE_PRODUCT.REQUEST, updateProduct),
    takeLatest(actions.DELETE_PRODUCT.REQUEST, deleteProduct),
    takeLatest(actions.UPLOAD_PRODUCT_IMAGES.REQUEST, uploadProductImages),
    takeLatest(actions.DELETE_PRODUCT_IMAGE.REQUEST, deleteProductImage),
    takeLatest(actions.FETCH_PRESENTATIONS.REQUEST, fetchPresentations),
    takeLatest(actions.CREATE_PRESENTATION.REQUEST, createPresentation),
    takeLatest(actions.UPDATE_PRESENTATION.REQUEST, updatePresentation),
    takeLatest(actions.DELETE_PRESENTATION.REQUEST, deletePresentation),
  ]);
}
